import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetQualityIndicatorsQueryResponse, GetQualityIndicatorsPathParams, GetQualityIndicatorsQueryParams, GetQualityIndicators400, GetQualityIndicators404, GetQualityIndicators500 } from "../types/GetQualityIndicators";

export const getQualityIndicatorsQueryKey = (culture: GetQualityIndicatorsPathParams["culture"], params?: GetQualityIndicatorsQueryParams) =>     [{url:`/api/requests/data/quality-indicators/culture/${culture}`,params:{culture:culture}},...(params ? [params] : [])] as const;
      export function getQualityIndicatorsQueryOptions <TData = GetQualityIndicatorsQueryResponse, TError = GetQualityIndicators400 | GetQualityIndicators404 | GetQualityIndicators500>(culture: GetQualityIndicatorsPathParams["culture"], params?: GetQualityIndicatorsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getQualityIndicatorsQueryKey(culture, params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/requests/data/quality-indicators/culture/${culture}`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Получение списка значений индикаторов качества для культуры
 * @link /api/requests/data/quality-indicators/culture/:culture
 */

export function useGetQualityIndicators <TData = GetQualityIndicatorsQueryResponse, TError = GetQualityIndicators400 | GetQualityIndicators404 | GetQualityIndicators500>(culture: GetQualityIndicatorsPathParams["culture"], params?: GetQualityIndicatorsQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getQualityIndicatorsQueryKey(culture, params);

  const query = useQuery<TData, TError>({
    ...getQualityIndicatorsQueryOptions<TData, TError>(culture, params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
